import React from 'react';
import { Link } from 'react-router-dom';
import './InvitationList.css';

function InvitationList({ invitations, eventId, onDelete }) {
  // Function to create URL-friendly slugs
  const createSlug = (text) => {
    if (!text) return '';
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  };
  
  // Handle link icon click - copy URL to clipboard
  const handleLinkClick = (invitation, event) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (!invitation.published) {
      // If not published, don't do anything
      return;
    }
    
    // Generate the URL for published invitation
    const eventSlug = createSlug(invitation.eventName || 'event');
    const invitationSlug = createSlug(invitation.name);
    
    // Get the user ID prefix - use the first 5 chars of the userId
    // Try to use the event's userId first, if available, otherwise use a placeholder
    const userIdentifier = invitation.userId?.substring(0, 5) || 'user';
    
    // Get the uniqueId for the invitation - first 6 chars of invitation ID
    const invUniqueId = invitation?.id?.substring(0, 6) || '';
    
    // Build the correct URL format with user ID and invitation unique ID
    const baseUrl = window.location.origin;
    const invitationUrl = `${baseUrl}/${userIdentifier}/${eventSlug}/${invitationSlug}-${invUniqueId}`;
    
    // Copy to clipboard
    navigator.clipboard.writeText(invitationUrl)
      .then(() => {
        // Show temporary success message
        const successMessage = document.createElement('div');
        successMessage.className = 'url-copy-success';
        successMessage.textContent = 'URL copied to clipboard!';
        document.body.appendChild(successMessage);
        
        setTimeout(() => {
          document.body.removeChild(successMessage);
        }, 2000);
      })
      .catch(err => {
        console.error('Failed to copy URL: ', err);
        alert('Failed to copy URL. Please try again.');
      });
  };
  
  return (
    <div className="invitation-list">
      {invitations.map((invitation) => (
        <div key={invitation.id} className="invitation-item">
          <div className="invitation-info">
            <h3 className="invitation-name">{invitation.name}</h3>
            <span className="invitation-status">
              {invitation.published ? 'Published' : 'Draft'}
            </span>
          </div>
          <div className="invitation-actions">
            <Link 
              to={`/events/${eventId}/invitation/${invitation.id}/edit`}
              className="edit-link"
            >
              Edit
            </Link>
            
            {/* Link icon instead of Preview button */}
            <button 
              className={`link-icon-btn ${invitation.published ? 'published' : 'unpublished'}`}
              onClick={(e) => handleLinkClick(invitation, e)}
              title={invitation.published ? "Copy invitation URL" : "Not published yet"}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="18" 
                height="18" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
            </button>
            
            <button 
              className="delete-btn" 
              onClick={() => onDelete(invitation.id)}
              title="Delete invitation"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="18" 
                height="18" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default InvitationList; 